export default "__VITE_ASSET__c373b3ba__"